<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/weier/special/inspection/order/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('teshusongjiandanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danjuzhuangtai')">
            <yi_dictionary_select clearable type="QUALITY_SPECIAL_INSPECTION_STATUS" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIds"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('songjianshijian')">
            <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" :maxTime="31 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status == 0">
            <el-popconfirm title="是否确认“审核通过”?" confirm-button-text="是" cancelButtonText="否" @confirm="approve(scope.row)" v-if="utils.checkPower('web_quality_management_weier_special_inspection_order_approve')">
              <el-button type="text" slot="reference">{{ $t('shenhetongguo') }}</el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 0">
            <el-popconfirm title="是否确认“审核驳回”?" confirm-button-text="是" cancelButtonText="否" @confirm="reject(scope.row)" v-if="utils.checkPower('web_quality_management_weier_special_inspection_order_reject')">
              <el-button type="text" slot="reference">{{ $t('shenhebohui') }}</el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
const date = new Date();
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();

export default {
  name: "web_quality_management_weier_special_inspection_order_list",
  data() {
    return {
      columns: [
        {
          label: 'teshusongjiandanhao',
          prop: 'no',
          width: 150
        },
        {
          label: 'danjuzhuangtai',
          prop: 'status',
          type: 'dictionary_tag',
          key: 'QUALITY_SPECIAL_INSPECTION_STATUS'
        },
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no',
          width: 130
        },
        {
          label: 'guishuchejian',
          prop: 'org.name',
          width: 130
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'songjianren',
          prop: 'createByObject.nickname',
          width: 130
        },
        {
          label: 'songjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 130
        },
        {
          label: 'shenheren',
          prop: 'reviewerObject.nickname',
          width: 130
        },
        {
          label: 'shenheshijian',
          prop: 'reviewTime',
          type: 'time',
          width: 230
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.createTimeStart = begin;
      this.yt.conditions.createTimeEnd = end;
      this.yt.get(1);
    }, 300);
  },
  methods: {
    exportExcel(){
      let params = this.yt.conditions;
      return this.http.get('/web/report/export/weier_special_inspection_order_export?orderBy=createTime desc', {params}).then(res => {
        this.$message.success(this.$t(res.msg));
        this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
      }).catch(error => {
        this.$message.error(this.$t(error));
      })
    },
    approve(order){
      this.http.post('/custom/weier/special/inspection/order/approve', order).then(res => {
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch(msg => {
        this.utils.errorMessage(msg);
      });
    },
    reject(order){
      this.http.post('/custom/weier/special/inspection/order/reject', order).then(res => {
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch(msg => {
        this.utils.errorMessage(msg);
      });
    },
  }
}
</script>

<style scoped>

</style>